import React, {createContext, useContext, useRef} from "react";
import LoadingBar from "react-top-loading-bar";

// ایجاد Context
const LoadingBarContext = createContext();

// ارائه‌دهنده Context
export const LoadingBarProvider = ({children}) => {
    const loadingBarRef = useRef(null); // مرجع به Loading Bar

    return (
        <LoadingBarContext.Provider value={loadingBarRef}>
            <div className={'loading-bar-wrapper'}>
                <LoadingBar color="#01a479" ref={loadingBarRef} shadow={false}/>
            </div>
            {children}
        </LoadingBarContext.Provider>
    );
};

// هوک برای استفاده از Context
export const useLoadingBar = () => {
    const context = useContext(LoadingBarContext);
    if (!context) {
        throw new Error("useLoadingBar باید در داخل LoadingBarProvider استفاده شود.");
    }
    return context;
};
